<mat-card class="portal-public-list">
  <mat-card-title>
    <div class="flex flex-col md:flex-row md:gap-4">
      <h1 class="portal-page-title">Approved Hemo Tech Licensees</h1>
      <!-- <button class="ml-auto" mat-button color="primary" (click)="downloadDocument()">Export List as CSV</button> -->
    </div>
  </mat-card-title>
  <mat-card-content>
    <mat-table [dataSource]="source" matSort #licenseeSort="matSort" aria-label="approved hemo tech licensees" class="portal-table">
      <ng-container matColumnDef="firstName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>First Name</mat-header-cell>
        <mat-cell *matCellDef="let record">
          <span class="mobile-label">First</span>
          {{ record.firstName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="lastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</mat-header-cell>
        <mat-cell *matCellDef="let record">
          <span class="mobile-label">Last</span>
          {{ record.lastName }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="certification">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Certification</mat-header-cell>
        <mat-cell *matCellDef="let record">
          <span class="mobile-label">Cert</span>
          {{ record.certification }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="certificationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Certification Date</mat-header-cell>
        <mat-cell *matCellDef="let record">
          <span class="mobile-label">Cert Date</span>
          {{ record.certificationDate | date: 'MM/dd/yyyy' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="expirationDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Expiration Date</mat-header-cell>
        <mat-cell *matCellDef="let record">
          <span class="mobile-label">Expires</span>
          {{ record.expirationDate | date: 'MM/dd/yyyy' }}
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="portal-interactive-row"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100]" #licenseePaginator="matPaginator">
    </mat-paginator>
  </mat-card-content>
</mat-card>
